<template>
  <div>
    <subPartnerLink
      :subPartners="subPartners"
      :partners="partners"
      @getSubPartners="getSubPartners"
    />
  </div>
</template>

<script>
import subPartnerLink from "@/components/link/subPartner.vue";

export default {
  components: {
    subPartnerLink,
  },
  data() {
    return {
      subPartners: [],
      partners: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Sub Partners" }]);
    this.initialise();
  },
  methods: {
    async initialise() {
      await this.getSubPartners();
      await this.getPartners();
    },
    async getPartners() {
      await this.$axios
        .get("partners")
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getSubPartners() {
      await this.$axios
        .get("sub_partners")
        .then((res) => {
          this.subPartners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
